import clienteAxios from "../services/axios"
import { authHeader } from "../helpers/auth-header"
import axios from "axios"
import { sourceHelper } from "../helpers/sourceHelper"
import Helpers from "../helpers/helpers"
import { buildQueryString, getTaggedDateFormat, METADATA_TYPE, payloadParsing } from "../utils"
import axiosInterceptor from "./axios"
import { history } from "../helpers/history"

export const documentsService = {
	toolsSearch,
	createTimelineSearch,
	setPriority,
	downloadDocument,
	setNewDateDocument,
	downloadMultipleDocumentContent,
	getAvailableSources,
	shareDocument,
	getFromToken,
	addComment,
	getAvailableCustomTags,
	addEditTag,
	deleteTag,
	getComments,
	getCommentCount,
	deleteComment,
	getStatusJobId,
	searchJobId,
	helpersDownloadDocument,
	helpersDownloadDocumentFAQ,
	helpersGetZipConfig,
	downloadDocumentAction,
	getDocumentsData,
	searchAllDocuments,
	getDocumentsMetadata,
	getFilesMetadata,
	getDocumentByPageNum,
	searchDocsView,
	getDocuments,
	getGraphData,
	getPageSearchOnDocuments,
	updateFileTag,
	getFileByPageNum,
	getSavedDateRange,
	postSavedDateRange,
	deleteSavedDateRange,
	checkNameAlreadyExist,
	getBillingCharacterCount,
	getBillingUserDetails,
}

function toolsSearch(
	positive_terms,
	negative_terms,
	filter = [],
	categories = [],
	treatLikeConcept = false,
	return_count = 10000,
	cancelToken = null,
	sourceApi,
	selectedTag = ""
) {
	//Text -> Target terms
	//Neg_text -> Ignore terms
	//Categories -> Blank
	//soucer -> Filter of type of document
	//return_content -> 10.0000
	//supress_content -> to hide content
	if (positive_terms.length === 0 && negative_terms.length === 0 && categories.length == 0) {
		return {
			count: 0,
			data: [],
		}
	}

	let filterResume = []
	let dateRange = []
	const taggedDate = { kind: METADATA_TYPE.FROM_TO_DATE_ARRAY, data: dateRange }
	const filterSources = { kind: METADATA_TYPE.STRING_ARRAY, data: filterResume }
	let dateFilter = { from: "", to: "" }
	let filtersActive = 0
	if (!Array.isArray(filter)) {
		//New filters method (based in sourceApi)
		try {
			if (sourceApi.hasOwnProperty("sources")) {
				sourceApi.sources.forEach(function (key) {
					if (filter[key]) {
						if (filter[key] === true) {
							filterResume.push(key)
							filtersActive++
						}
					} else {
						let otherKeys = sourceHelper.getKeyArrayHumanValue(sourceHelper.getHumanValue(key))
						otherKeys.forEach(function (keyAux) {
							if (filter.hasOwnProperty(keyAux)) {
								if (filter[keyAux] === true) {
									filterResume.push(key)
									filtersActive++
								}
							}
						})
					}
				})
			}
		} catch (error) {
			console.log(error)
		}
		try {
			if (filter.toDate !== "") {
				dateFilter.to = new Date(filter.toDate)
				dateFilter.to = getTaggedDateFormat(dateFilter.to)
				if (dateFilter.to !== "NaN-aN-aN") dateRange[1] = dateFilter.to
			}
			if (filter.fromDate !== "") {
				dateFilter.from = new Date(filter.fromDate)
				dateFilter.from = getTaggedDateFormat(dateFilter.from)
				if (dateFilter.from !== "NaN-aN-aN") dateRange[0] = dateFilter.from
			}
			// To do: Check the scenario if no file type filter is selected
			// if(filtersActive===0){
			//     return {data: {count: 0, data: []}};
			// }
		} catch (e) {}
	}

	let positiveInput = ""

	if (positive_terms.length > 0) {
		positiveInput = positive_terms.join(" ")
	}

	let negativeInput = ""
	if (negative_terms.length > 0) {
		negativeInput = negative_terms
	}

	const input = {
		text: positive_terms,
		neg_text: negativeInput,
		categories: categories,
		source: filterSources,
		return_count: return_count,
		skip_count: 0,
		dynamic_search: 0,
		suppress_content: false,
		treat_like_concept: treatLikeConcept,
		or_flag: treatLikeConcept,
	}

	if (!!dateRange.length) {
		if (dateRange[0] === undefined) dateRange[0] = "1900-01-01" //To do: Need to fix it to get the oldest doc date, for now keeping it '1900-01-01' as per LD-215
		if (dateRange[1] === undefined) dateRange[1] = getTaggedDateFormat(new Date())
		input.tagged_date = taggedDate
	}

	if (!!selectedTag) {
		const tags = { kind: METADATA_TYPE.STRING_ARRAY, data: [selectedTag === "untaged" ? "" : selectedTag] }
		input["tags"] = tags
	}
	let auxHeader = { headers: authHeader() }
	if (cancelToken !== null) {
		auxHeader["cancelToken"] = cancelToken.token
	}
	const payload = payloadParsing(input)
	return clienteAxios.post("/file/search", payload, auxHeader)
}

function createTimelineSearch(payload) {
	let auxHeader = { headers: authHeader() }
	return clienteAxios.post("/file/search", payload, auxHeader)
}

function searchDocsView(
	positive_terms,
	negative_terms,
	filter = [],
	categories = [],
	treatLikeConcept = false,
	return_count = 10000,
	cancelToken = null,
	sourceApi = [],
	skip_count = 0,
	selectedTag = "",
	currentSort = ""
) {
	// if (positive_terms.length === 0 && negative_terms.length === 0 && categories.length == 0) {
	// 	return {
	// 		count: 0,
	// 		data: [],
	// 	}
	// }

	let filterResume = []
	let dateRange = []
	const taggedDate = { kind: METADATA_TYPE.FROM_TO_DATE_ARRAY, data: dateRange }
	const filterSources = { kind: METADATA_TYPE.STRING_ARRAY, data: filterResume }
	let dateFilter = { from: "", to: "" }
	let filtersActive = 0
	if (!Array.isArray(filter)) {
		try {
			sourceApi.forEach(function (key) {
				if (filter[key]) {
					if (filter[key] === true) {
						filterResume.push(key)
						filtersActive++
					}
				} else {
					let otherKeys = sourceHelper.getKeyArrayHumanValue(sourceHelper.getHumanValue(key))
					otherKeys.forEach(function (keyAux) {
						if (filter.hasOwnProperty(keyAux)) {
							if (filter[keyAux] === true) {
								filterResume.push(key)
								filtersActive++
							}
						}
					})
				}
			})
		} catch (error) {
			console.log(error)
		}

		try {
			if (filter.toDate !== "") {
				dateFilter.to = new Date(filter.toDate)
				dateFilter.to = getTaggedDateFormat(dateFilter.to)
				if (dateFilter.to !== "NaN-aN-aN") dateRange[1] = dateFilter.to
			}
			if (filter.fromDate !== "") {
				dateFilter.from = new Date(filter.fromDate)
				dateFilter.from = getTaggedDateFormat(dateFilter.from)
				if (dateFilter.from !== "NaN-aN-aN") dateRange[0] = dateFilter.from
			}
		} catch (e) {}
	}

	let positiveInput = ""

	if (positive_terms.length > 0) {
		positiveInput = positive_terms.join(" ")
	}

	let negativeInput = ""
	if (negative_terms.length > 0) {
		negativeInput = negative_terms
	}

	const input = {
		text: positive_terms,
		neg_text: negativeInput,
		categories: categories,
		source: filterSources,
		return_count: return_count,
		skip_count: skip_count,
		dynamic_search: 0,
		suppress_content: false,
		treat_like_concept: treatLikeConcept,
		mode: "PAGE",
	}

	if (!!dateRange.length) {
		if (dateRange[0] === undefined) dateRange[0] = "1900-01-01" //To do: Need to fix it to get the oldest doc date, for now keeping it '1900-01-01' as per LD-215
		if (dateRange[1] === undefined) dateRange[1] = getTaggedDateFormat(new Date())
		input.tagged_date = taggedDate
	}

	if (!!selectedTag) {
		const tags = { kind: METADATA_TYPE.STRING_ARRAY, data: [selectedTag === "untaged" ? "" : selectedTag] }
		input["tags"] = tags
	}

	if (!!currentSort) {
		const sort = { field: "tagged_date", ordering: currentSort === "asc" ? 1 : -1 }
		input["sort"] = sort
	}

	let auxHeader = { headers: authHeader() }
	if (cancelToken !== null) {
		auxHeader["cancelToken"] = cancelToken.token
	}

	// return clienteAxios.post('/tools/search',input, auxHeader);
	return clienteAxios.post("/p_search", input, auxHeader)
	//return axios.post('http://localhost:8089/https://www.hiniestic.com/testApi/timeline2.json',input, {"headers": authHeader()});
}

function searchAllDocuments(
	positive_terms,
	negative_terms,
	filter = [],
	categories = [],
	treatLikeConcept = false,
	return_count = 10000,
	cancelToken = null,
	sourceApi,
	skip_count
) {
	try {
		let filterResume = []
		let dateRange = []
		const taggedDate = { kind: METADATA_TYPE.FROM_TO_DATE_ARRAY, data: dateRange }
		const filterSources = { kind: METADATA_TYPE.STRING_ARRAY, data: filterResume }
		// const filterSources = { kind: METADATA_TYPE.STRING_ARRAY, data: sourceApi?.sources || [] };
		let dateFilter = { from: "", to: "" }
		let filtersActive = 0
		if (!Array.isArray(filter)) {
			if (sourceApi.hasOwnProperty("sources")) {
				sourceApi.sources.forEach(function (key) {
					if (filter[key]) {
						if (filter[key] === true) {
							filterResume.push(key)
							filtersActive++
						}
					} else {
						let otherKeys = sourceHelper.getKeyArrayHumanValue(sourceHelper.getHumanValue(key))
						otherKeys.forEach(function (keyAux) {
							if (filter.hasOwnProperty(keyAux)) {
								if (filter[keyAux] === true) {
									filterResume.push(key)
									filtersActive++
								}
							}
						})
					}
				})
			}

			if (filter.toDate !== "") {
				dateFilter.to = new Date(filter.toDate)
				dateFilter.to = getTaggedDateFormat(dateFilter.to)
				if (dateFilter.to !== "NaN-aN-aN") dateRange[1] = dateFilter.to
			}
			if (filter.fromDate !== "") {
				dateFilter.from = new Date(filter.fromDate)
				dateFilter.from = getTaggedDateFormat(dateFilter.from)
				if (dateFilter.from !== "NaN-aN-aN") dateRange[0] = dateFilter.from
			}
		}

		let positiveInput = ""
		if (positive_terms.length > 0) {
			positiveInput = positive_terms.join(" ")
		}

		let negativeInput = ""
		if (negative_terms.length > 0) {
			negativeInput = negative_terms.join(" ")
		}

		const input = {
			text: positive_terms,
			neg_text: negativeInput,
			categories: categories,
			source: filterSources,
			return_count: return_count,
			skip_count: skip_count,
			dynamic_search: 0,
			suppress_content: false,
			treat_like_concept: treatLikeConcept,
		}

		if (filter?.tags) {
			const tags = { kind: METADATA_TYPE.STRING_ARRAY, data: [filter.tags === "untaged" ? "" : filter.tags] }
			input["tags"] = tags
		}

		if (!!dateRange.length) {
			if (dateRange[0] === undefined) dateRange[0] = "1900-01-01" //To do: Need to fix it to get the oldest doc date, for now keeping it '1900-01-01' as per LD-215
			if (dateRange[1] === undefined) dateRange[1] = getTaggedDateFormat(new Date())
			input.tagged_date = taggedDate
		}
		let auxHeader = { headers: authHeader() }
		if (cancelToken !== null) {
			auxHeader["cancelToken"] = cancelToken.token
		}
		return clienteAxios.post("/p_search", input, auxHeader)
	} catch (error) {
		console.error(error)
	}
}

function getStatusJobId(jobId) {
	return clienteAxios.get("/job/" + jobId, { headers: authHeader() })
}

function searchJobId(jobId) {
	return clienteAxios.get("/p_search/" + jobId, { headers: authHeader() })
}

function setPriority(document_id, priority) {
	return clienteAxios.post(`/documents/tag?doc_id=${document_id}&tag_id=${priority}`, { headers: authHeader() })
}

function downloadDocument(document_id) {
	return clienteAxios.get(`/documents/download/${document_id}`, { responseType: "stream" }, { headers: authHeader() })
}

function setNewDateDocument(document_id, newdate) {
	let newdateFormated = new Date(newdate)
	return clienteAxios.put(
		"/documents/datetime",
		{
			id: document_id,
			tagged_date: `${newdateFormated.getFullYear()}-${("0" + (newdateFormated.getMonth() + 1)).slice(-2)}-${(
				"0" + newdateFormated.getDate()
			).slice(-2)}`,
		},
		{ headers: authHeader() }
	)
}

// function downloadDocumentContent(document_id){
//     return clienteAxios.post(
//         '/documents/content',
//         {"doc_ids": document_id},
//         {"headers": authHeader()}
//     );
// }

function downloadMultipleDocumentContent(idList) {
	return clienteAxios.post("/documents", idList, { headers: authHeader() })
}

function addComment(docId, comment, comment_id = null) {
	let dataAux = { file_id: docId, comment: comment }
	if (comment_id !== null) {
		dataAux["comment_id"] = comment_id
		return clienteAxios
			.put(`/file/comment/${comment_id}?comment=${comment}`, dataAux, { headers: authHeader() })
			.then((response) => {
				return response
			})
			.catch((error) => {
				return error
			})
	} else {
		return clienteAxios
			.post(`/file/comment?file_id=${docId}&comment=${comment}`, dataAux, { headers: authHeader() })
			.then((response) => {
				return response
			})
			.catch((error) => {
				return error
			})
	}
}
function deleteComment(comment_id) {
	return clienteAxios.delete("documents/comments/" + comment_id, {}, { headers: authHeader() })
}
function addEditTag(name, color, tag_id = null) {
	let auxData = {
		name: name,
		color_id: color,
		creation_time: new Date(),
	}
	if (tag_id) {
		auxData["id"] = tag_id
		return clienteAxios.put("/tag", auxData, { headers: authHeader() })
	} else {
		return clienteAxios.post("/tag", auxData, { headers: authHeader() })
	}
}
function deleteTag(id) {
	return clienteAxios.get("/tags/delete/" + id, {}, { headers: authHeader() })
}

function getComments(docId) {
	return clienteAxios.get("/documents/comments/" + docId, {}, { headers: authHeader() })
}
function getCommentCount(docId) {
	return clienteAxios.get("/documents/comment/count/" + docId, {}, { headers: authHeader() })
}
function getAvailableSources() {
	return clienteAxios.get("/documents/sources", {}, { headers: authHeader() })
}
// Keeping it for reference for some time, Need to delete it later
// function shareDocument(docsIds){
//     return clienteAxios.post(
//         '/buck_list',
//         {"ids": docsIds},
//         {"headers": authHeader()}
//     );
// }

function shareDocument(docsIds) {
	return clienteAxios.put("tools/bulk-list", docsIds, { headers: authHeader() })
}

function getFromToken(token) {
	return clienteAxios.get(`/seq_download/${token}`)
}

function getAvailableCustomTags() {
	//return response;
	return clienteAxios.get("/tag", {}, { headers: authHeader() })
}

function helpersDownloadDocument(description) {
	var filename = `${description}.zip`
	let response = Helpers.httpRequest(`${window._env_.REACT_APP_API_URL}/documents/download/${description}`, "get", [], authHeader())
		// 1. Convert the data into 'blob'
		.then((response) => response.blob())
		.then((blob) => {
			// 2. Create blob link to download
			const url = window.URL.createObjectURL(new Blob([blob]))
			const link = document.createElement("a")
			link.href = url
			link.setAttribute("download", filename)
			// 3. Append to html page
			document.body.appendChild(link)
			// 4. Force download
			link.click()
			// 5. Clean up and remove the link
			link.parentNode.removeChild(link)
			document.getElementById("spinnerDownload").hidden = true
			document.getElementById("btnMultipleDownload").disabled = false
		})

	return response
}

function helpersDownloadDocumentFAQ(filename) {
	let response = Helpers.httpRequest(`${window._env_.REACT_APP_API_URL}documents/faq`, "post", [], authHeader())
		// 1. Convert the data into 'blob'
		.then((response) => response.blob())
		.then((blob) => {
			// 2. Create blob link to download
			const url = window.URL.createObjectURL(new Blob([blob]))
			const link = document.createElement("a")
			link.href = url
			link.setAttribute("download", filename)
			// 3. Append to html page
			document.body.appendChild(link)
			// 4. Force download
			link.click()
			// 5. Clean up and remove the link
			link.parentNode.removeChild(link)
		})

	return response
}

function helpersGetZipConfig(documents_id) {
	return clienteAxios.get("/documents/download/zip?" + documents_id, { responseType: "blob" }, { headers: authHeader() })
}

function downloadDocumentAction(document_id) {
	return clienteAxios.get("/documents/download?doc_id=" + document_id, { responseType: "blob" }, { headers: authHeader() })
}

function getDocumentsData(docIdArray) {
	return clienteAxios.post("/documents", docIdArray, { headers: authHeader() })
}

function getDocumentsMetadata(docIdArray) {
	return clienteAxios.post("/documents/metadata", docIdArray, { headers: authHeader() })
}

function getFilesMetadata(fileIdArray, context_id, context) {
	const api = context_id ? `/file/metadata?context=${context}&context_id=${context_id}` : `/file/metadata`
	return clienteAxios.post(api, fileIdArray, {
		headers: authHeader(),
	})
}

function getDocumentByPageNum(docId, pageNumber) {
	return clienteAxios.post(`/documents/${docId}/${pageNumber}`, {}, { headers: authHeader() })
}

function getDocuments(payload) {
	return clienteAxios.post("/file/search", payload, { headers: authHeader() })
}

function getGraphData(payload) {
	return clienteAxios.post("/timeline/get_timeline", payload, { headers: authHeader() })
}

function getPageSearchOnDocuments(payload) {
	return clienteAxios.post("/file/page_search", payload, { headers: authHeader() })
}

async function updateFileTag(payload) {
	if (payload?.type === "remove") {
		return axiosInterceptor
			.delete(`/file/tag?file_id=${payload?.document_id}&tag_id=${payload?.tag_id}&context_id=${payload?.context_id}`, payload)
			.then((response) => {
				return response
			})
			.catch((error) => {
				return error
			})
	} else {
		return axiosInterceptor
			.put(
				`/file/tag?file_id=${payload?.document_id}&tag_id=${payload?.tag_id}&context=${payload?.context}&context_id=${payload?.context_id}`,
				payload
			)
			.then((response) => {
				return response
			})
			.catch((error) => {
				return error
			})
	}
}

function getFileByPageNum(docId, pageNumber, context_id, context) {
	const api = context_id ? `/file/${docId}/${pageNumber}?context=${context}&context_id=${context_id}` : `/file/${docId}/${pageNumber}`
	return clienteAxios
		.post(api, {}, { headers: authHeader() })
		.then((response) => {
			return response
		})
		.catch((error) => {
			return error
		})
}

function getSavedDateRange() {
	return clienteAxios.get("/timeline", { headers: authHeader() })
}

function postSavedDateRange(data) {
	return clienteAxios.post("/timeline", data, { headers: authHeader() })
}

function deleteSavedDateRange(data) {
	return clienteAxios.delete(`/timeline?timeline_id=${data}`, { headers: authHeader() })
}

function checkNameAlreadyExist(data) {
	return clienteAxios.post("/timeline/name", { name: data }, { headers: authHeader() })
}

function getBillingCharacterCount(data) {
	return clienteAxios.post("/billing/char_details", data, { headers: authHeader() })
}

function getBillingUserDetails(data) {
	return clienteAxios.post("/billing/user_details", data, { headers: authHeader() })
}
